import tw from "twin.macro";

import firstSrc from "../../images/first_page_FILL0_wght200_GRAD0_opsz20.svg";
import lastSrc from "../../images/last_page_FILL0_wght200_GRAD0_opsz20.svg";
import nextSrc from "../../images/navigate_next_FILL0_wght200_GRAD0_opsz20.svg";
import prevSrc from "../../images/navigate_before_FILL0_wght200_GRAD0_opsz20.svg";

const PagerContainer = tw.div`flex justify-center items-center space-x-2 mb-4`;
const PagerButton = tw.button`text-sm p-2 disabled:opacity-50 transition hover:bg-white focus:bg-white border border-transparent hover:border-blue-700 focus:border-blue-700`;

const Pager = ({ page, numPages, pageChangeCb }) => {
  return numPages > 1 ? (
    <PagerContainer>
      <PagerButton
        disabled={page == 1}
        type="button"
        onClick={() => pageChangeCb(1)}
      >
        <img width="24" src={firstSrc} alt="First Page" />
      </PagerButton>
      <PagerButton
        disabled={page == 1}
        type="button"
        onClick={() => pageChangeCb(page - 1)}
      >
        <img width="24" src={prevSrc} alt="Previous Page" />
      </PagerButton>
      <div tw="hidden md:block space-x-2">
        {Array.from({ length: numPages }, (_, i) => (
          <PagerButton
            key={i}
            type="button"
            disabled={page - 1 == i}
            onClick={() => pageChangeCb(i + 1)}
          >
            {i + 1}
          </PagerButton>
        ))}
      </div>
      <PagerButton
        disabled={page == numPages}
        type="button"
        onClick={() => pageChangeCb(page + 1)}
      >
        <img width="24" src={nextSrc} alt="Next Page" />
      </PagerButton>
      <PagerButton
        disabled={page == numPages}
        type="button"
        onClick={() => pageChangeCb(numPages)}
      >
        <img width="24" src={lastSrc} alt="Last Page" />
      </PagerButton>
    </PagerContainer>
  ) : null;
};

export default Pager;
